<template>
  <div v-if="open" id="NfeReceipt">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text class="pb-0">
          <div class="pt-5 pb-1 d-flex align-center justify-space-between">
            <h1>Verificar Canhoto</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <v-row justify="center">
            <v-col cols="12" md="12" class="mb-2 pb-0">
              <div v-if="nfeReceipts.length > 0">
                <div v-if="receiptsLoaded">
                  <div v-for="imgReceipt in nfeReceipts" :key="imgReceipt.linkDownload">
                    <div style="position: relative">
                      <img :src="imgReceipt.srcImage" class="w-100 rounded elevation-1" />
                      <div class="delete-receipt-btn">
                        <div>
                          <div class="text-center">
                            <v-menu
                              v-if="!readonly"
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-width="100"
                              nudge-left="78"
                              nudge-top="80"
                              top
                              offset-y
                            >
                              <template v-slot:activator="{ on: menu1, attrs }">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on: tooltip }">
                                    <v-btn
                                      :loading="isDeleteReceiptLoading"
                                      v-bind="attrs"
                                      v-on="{ ...tooltip, ...menu1 }"
                                      class="ma-2"
                                      fab
                                      dark
                                      small
                                      color="error"
                                    >
                                      <v-icon dark> mdi-delete </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Deletar</span>
                                </v-tooltip>
                              </template>

                              <v-card>
                                <v-card-title>
                                  <span class="mx-auto my-0 pb-0 text-body-1"> Deletar canhoto? </span>
                                </v-card-title>

                                <v-card-actions class="d-flex justify-center">
                                  <v-btn small text @click="menu = false"> Cancelar </v-btn>
                                  <v-btn
                                    small
                                    color="error"
                                    text
                                    @click="(menu = false), removeNfeReceipt(imgReceipt.id)"
                                  >
                                    Deletar
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-menu>
                            <v-tooltip v-if="!imgReceipt.isValidated && !readonly" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="appovreANfeReceipt(imgReceipt.id)"
                                  :loading="isApproveLoading"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ma-2"
                                  fab
                                  dark
                                  small
                                  color="success"
                                >
                                  <v-icon dark> mdi-check </v-icon>
                                </v-btn>
                              </template>
                              <span>Aprovar</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="imgReceipt.isValidated" class="mt-3 mb-2">
                      <v-chip class="ma-2" color="success" label text-color="white">
                        <v-icon left> mdi-check </v-icon>
                        Canhoto Aprovado {{ getValidatorName(imgReceipt) }}
                      </v-chip>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column align-center" v-else>
                  <span class="pb-2">Carregando Canhotos...</span>
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </div>

              <div v-if="readonly && receiptsLoaded && !nfeReceipts.length" class="py-4">
                Esta nota não possui canhoto.
              </div>

              <div v-else-if="nfeReceipts.length === 0" class="area-drop my-6" :class="{ ativo: imagesReceipt.length }">
                <div class="message-drop">
                  <v-icon> mdi-folder-multiple-image </v-icon>
                  <p>
                    {{ imagesReceipt.length ? 'Arquivo selecionado' : 'Selecione ou arraste um arquivo aqui.' }}
                  </p>
                </div>

                <input required type="file" @change="(e) => uploadImageReceiptSuccess(e)" />
              </div>
            </v-col>
          </v-row>

          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <template v-if="readonly">
            <v-btn color="info" class="flex-grow-1" large @click="close(false, null)"> Voltar </v-btn>
          </template>
          <template v-else>
            <v-btn color="error" class="flex-grow-1" large @click="close(false, null)"> Cancelar </v-btn>
            <v-btn
              :loading="loading"
              :disabled="imagesReceipt.length === 0"
              color="success"
              class="flex-grow-1"
              large
              @click="uploadImagesReceipt()"
            >
              Confirmar
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Base64Mixin from '../../mixins/base64.mixin';
import { baseURL } from '@/api/index';
export default {
  name: 'NfeReceipt',
  props: {
    open: {
      default: false,
      type: Boolean
    },
    nfeId: {
      default: null,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    }
  },
  mixins: [Base64Mixin],
  data: () => ({
    loading: false,
    nfeReceipts: [],
    imagesReceipt: [],
    imagesReceiptUpload: [],
    message: [],
    receiptsLoaded: false,
    isApproveLoading: false,
    isDeleteReceiptLoading: false,
    menu: false
  }),
  watch: {
    open: {
      handler(isOpen) {
        if (isOpen) {
          this.imagesReceipt = [];
          this.imagesReceiptUpload = [];
          this.fetchAllReceiptNfeById();
        }
      }
    }
  },
  methods: {
    ...mapActions('NfeStore', [
      'fetchReceiptNfeById',
      'getSrcImage',
      'appovreNfeReceipt',
      'deleteNfeReceipt',
      'createReceiptNfe'
    ]),
    async fetchAllReceiptNfeById() {
      this.receiptsLoaded = false;
      try {
        this.nfeReceipts = await this.fetchReceiptNfeById(this.nfeId);

        if (this.nfeReceipts.length > 0) {
          let newNfeReceipts = [];
          try {
            const urlImage = `${baseURL}pt/${this.nfeReceipts[0].linkDownload}`;
            const image = await this.getSrcImageReceipt(urlImage);

            try {
              const dataFile = await this.toBase64(image);

              const newItem = {
                ...this.nfeReceipts[0],
                srcImage: dataFile
              };

              newNfeReceipts.push(newItem);
              this.nfeReceipts = newNfeReceipts;
            } catch (e) {
              console.error(e);
            }
          } catch (e) {
            console.error(e);
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.receiptsLoaded = true;
      }
    },
    async getSrcImageReceipt(endpoint) {
      try {
        const data = await this.getSrcImage(endpoint);

        return data;
      } catch (e) {
        console.error(e);
        this.errorsType = 'error';
        this.errors = ['Opss, algo deu errado!'];
      }
    },
    async appovreANfeReceipt(id) {
      try {
        this.isApproveLoading = true;
        await this.appovreNfeReceipt([id]);

        this.message = {
          errors: ['Canhoto aprovado com sucesso!'],
          errorsType: 'success'
        };
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.isApproveLoading = false;
        this.nfeReceipts = [];
        this.fetchAllReceiptNfeById();
        this.$emit('canhotoApprove', this.message);
      }
    },
    async removeNfeReceipt(id) {
      try {
        this.receiptsLoaded = true;
        this.isDeleteReceiptLoading = true;
        const data = await this.deleteNfeReceipt(id);
        if (data.success) {
          this.message = {
            errors: ['Canhoto deletado com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: ['Erro ao deletar canhoto'],
            errorsType: 'error'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.isDeleteReceiptLoading = false;
        this.receiptsLoaded = false;
        this.nfeReceipts = [];
        this.$emit('canhotoApprove', this.message);
        this.fetchAllReceiptNfeById();
      }
    },
    getValidatorName(receipt) {
      return receipt.validatorName ? `por ${receipt.validatorName}` : '';
    },
    uploadImageReceiptSuccess(image) {
      this.imagesReceipt = image.target.files;
      const formData = new FormData();

      formData.append('file', image.target.files[0]);

      this.imagesReceiptUpload = formData;
    },
    async uploadImagesReceipt() {
      this.loading = true;
      const params = {
        id: this.nfeId,
        body: this.imagesReceiptUpload
      };
      try {
        const data = await this.createReceiptNfe(params);
        if (data.success) {
          this.message = {
            errors: ['Canhoto anexado com sucesso!'],
            errorsType: 'success'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.loading = false;
        this.close(true, this.message);
      }
    },
    close(hasChange, message) {
      this.menu = false;
      this.$emit('closeNfeReceipt', hasChange, message);
    }
  }
};
</script>

<style lang="scss" scoped>
.delete-receipt-btn {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
